import * as React from "react";
import { useState } from "react";
import axios from "axios";
import polarLogo from "../../../assets/images/polar.svg";
import { environment } from "src/environments/environment";

const useCustomNavigate = () => {
  return (path: string) => {
    window.location.href = path;
  };
};

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useCustomNavigate(); 

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setError("");
    setMessage("");
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitted(true);
    setError("");
    setMessage("");

    if (!email) {
      setError("Email is required.");
      return;
    }

    try {
      setIsLoading(true);
      await axios.post(`${environment.host}/request-reset-password`, {       
        host: window.location.protocol + '//' + window.location.host + '/reset',
        email: email
      });
      setMessage("Reset link has been sent to your email.");
      navigate("/login");
    } catch (err) {
      const errorRes: any = err;
      if (errorRes && errorRes.response.data.message) {
        setError(errorRes.response.data.message);
      } else {
        setError("Failed to send reset email. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="reset-password" className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="login-container max-w-md w-full">
        <div className="forget-form-div bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <form className="form" onSubmit={handleSubmit}>
            <div className="form-input-block space-y-6">
              <div className="logo-div text-center mb-6">
                <img
                  src={polarLogo}
                  alt="Polar Logo"
                  className="polar-logo mx-auto h-10 w-auto"
                />
              </div>
              
              <div className="text-center">
                <div className="form-title-1 text-lg font-medium text-gray-900 mb-2">
                  Forgot Password?
                </div>
                <div className="form-p text-sm text-gray-600 mb-6 leading-snug">
                  Enter your email address and we'll send you a link to reset your password.
                </div>
              </div>

              <div>
                <input
                  type="email"
                  className="form-input w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder-gray-500"
                  placeholder="Email Address"
                  value={email}
                  onChange={handleChange}
                />
                {message && (
                  <div className="form-success mt-1 text-sm text-green-600">{message}</div>
                )}
                {error && (
                  <div className="custom-form-error mt-1 text-sm ">{error}</div>
                )}
              </div>
            </div>

            <div className="form-input-block mt-6 space-y-4">
              <button 
                type="submit" 
                className="btn login-btn w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Reset Password"}
              </button>
            </div>
            <div className="text-center mb-6"> 
              <a
                href="/login"
                className="back-link w-full border border-gray-300 text-gray-700 py-3 px-4 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 font-medium inline-block text-center"
              >
                Back to Sign In
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;